var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-main"},[_c('div',{staticClass:"d-none d-md-block desktop-main"},[_c('desktop-configure-slot-calendar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }